import { useQuery } from "@tanstack/react-query";
import { authApi } from "../httpClient";
import { ErrorResponse } from "../../models/apiResponse";

const useQueryAuth = ({ enabled = true }: { enabled?: boolean }) => {
  return useQuery(["auth"], () => authApi().get<any | ErrorResponse>(), {
    staleTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled,
  });
};

export default useQueryAuth;
